import React from 'react'

import ActionIcon from "../../../assets/images/icons/ActionDotsIcon.svg"
import { useEffect, useState } from "react";
import PopupWithActions from "../../../components/Popup/PopupWithAction";
import { showSnackBar } from "../../../components/Snackbar/Snackbar";
import { NavLink } from "react-router-dom";
import { phoneNumber } from "../../../utils/payment"
import { formatDateOnlyField } from "../../../utils/date";
import { TABLE_HEAD_ROW } from "../../../components/Table/tableCardClass"
import { handleTableId } from "../../../helpers/helper"

const TableContactList = ({ data }) => {
  const titles = ['ID', 'First Name', 'Last Name', 'Primary Phone', 'Email', 'Suite/Apt#', 'City', 'State', 'Zip', "DOB"]
  const [anchor, setAnchor] = useState(null);
  const [open, setOpen] = useState(false);
  const [reqError, setReqError] = useState('');
  const [customerId, setCustomerId] = useState('');
  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError]);

  const handleOpen = (event, id) => {
    setAnchor(event.currentTarget);
    setOpen(true);
    setCustomerId(id);
  };

  const handleClose = () => {
    setAnchor(null);
    setOpen(false);
  };

  return (
    <div className="overflow-x-auto">
      <table className="text-md text-left w-full text-text-primary min-w-max border-collapse">
        <thead>
          <tr className={`${TABLE_HEAD_ROW} px-10`}>
            {titles.map((el, i) => (
              <th key={i} className="pl-5 py-4 font-semibold text-[13px] uppercase">
                {el}
              </th>
            ))}
            <th className="px-3 pr-5 text-right font-semibold text-[13px] uppercase">Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.customers?.map((element, i) => (
            <React.Fragment key={i}>
              <tr className="border-b border-divider hover:bg-black/[0.04] dark:hover:bg-white/[0.04] transition-colors">
                <td className="pl-5 py-4 text-primary-main font-semibold">{handleTableId(element?._id)}</td>
                <td className="pl-5 py-4">{element?.firstName}</td>
                <td className="pl-5 py-4">{element?.lastName}</td>
                <td className="pl-5 py-4">{phoneNumber(element?.primaryPhone)}</td>
                <td className="pl-5 py-4 max-w-[220px] overflow-hidden text-ellipsis break-words" title={element?.email}>{element?.email}</td>
                <td className="pl-5 py-4">{element?.address?.address}</td>
                <td className="pl-5 py-4">{element?.address?.aptNumber}</td>
                <td className="pl-5 py-4">{element?.address?.city}</td>
                <td className="pl-5 py-4">{element?.address?.state}</td>
                <td className="pl-5 py-4">{element?.address?.zip}</td>
                <td className="pl-5 py-4">{element?.dateOfBirth ? formatDateOnlyField(element?.dateOfBirth) : 'N/A'}</td>
                <td className="pl-5 pr-[30px] py-4 flex justify-end cursor-pointer"
                  onClick={(e) => open ? handleClose() : handleOpen(e, element._id)}>
                  <img src={ActionIcon} alt="threeDots" className="dark:invert dark:opacity-70" />
                </td>
              </tr>
              <tr>
                <td colSpan={titles?.length + 1}>
                  <PopupWithActions
                    anchor={anchor}
                    open={open}
                    handleClose={handleClose}
                  >
                    <div className="flex flex-col">
                      <NavLink to={`/customer/edit/${customerId}`} className="cursor-pointer border-b rounded-md border-b-divider p-[14px] text-text-primary hover:bg-black/[0.04] dark:hover:bg-white/[0.04]" >
                        Edit
                      </NavLink>
                    </div>
                  </PopupWithActions>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableContactList;
